import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../../../Common/Loader/loader";
import {
  getVehicleNotDeployedReasons,
  getVehicleNotDeployedRemarks,
  innergetNotReportedAtWard,
  innerTotalgetNotReportedAtWard1,
  saveVehicleNotDeployedRemark,
} from "../../../Apis/satReportsApi";
import CustomDataTable from "../../../Common/ReportTable/ReportTable";
import { GetZone } from "../../../Apis/organizationApi";
import { Field, Form, Formik } from "formik";

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import useFilterStore from "./store/useFilterStore";
import { formattedDate, getCurrentDateTime1, getCurrentISTDate } from "../../../Common/helper/helpar";
import { getWritePermission } from "../../AssetVehicle/utils/helpers";

import TableSkeleton from "../../AllotedMaster/TableSkeleton";

const NotReportedAtWard = () => {
  const {
    zoneWiseFilters
  } = useFilterStore();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [zoneName, setZoneName] = useState("");
  const location = useLocation();
  const navigationState = location.state;
  const { data: initialData, ZoneId, Date: reportDate, VehicleTypeId, corporationId, ownerTypeId, vehicleId, transferStationId, vehicleNumber, CollectionTypeId, allZones } = navigationState;
  const data = initialData || [];
  const [zonesData, setZonesData] = useState([]);
  const [satNotReportedWard, setsatNotReportedWard] = useState(data);
  const [notDeployedReasons, setNotDeployedReasons] = useState([]);
  const [selectedReasons, setSelectedReasons] = useState({});
  const [remarkInputs, setRemarkInputs] = useState({});
  const [savedRemarks, setSavedRemarks] = useState([]);
  const [submittingRows, setSubmittingRows] = useState({});

  const getRowKey = (row, rowIndex) =>
    row.vehicleId || row.vehicleNumber || `${row.wardId || "ward"}-${rowIndex}`;

  const getReasonValue = (reason) =>
    reason.vehicleNotDeployedReasonId ??
    reason.notDeployedReasonId ??
    reason.reasonId ??
    reason.id;

  const getReasonLabel = (reason) =>
    reason?.vehicleNotDeployedReasonName ??
    reason?.notDeployedReasonName ??
    reason?.reasonName ??
    reason?.reason ??
    reason?.name;

  const handleReasonChange = (row, rowIndex, value) => {
    setSelectedReasons((current) => ({
      ...current,
      [getRowKey(row, rowIndex)]: value,
    }));
  };

  const getSavedRemark = (row) =>
    savedRemarks.find((remark) => String(remark.vehicleId) === String(row.vehicleId));

  const getSavedRemarkText = (remark) =>
    remark?.remarks ?? remark?.remark ?? remark?.remarksText ?? "";

  const getSavedReasonId = (remark) =>
    remark?.reasonId ??
    remark?.vehicleNotDeployedReasonId ??
    remark?.notDeployedReasonId;

  const getReasonLabelById = (reasonId) => {
    const reason = notDeployedReasons.find(
      (item) => String(getReasonValue(item)) === String(reasonId)
    );
    return getReasonLabel(reason) || "N/A";
  };

  const getTodayISO = () => new Date().toISOString().split("T")[0];

  const getDeploymentDate = (row) =>
    row.deploymentDate || row.date || row.reportDate || zoneWiseFilters.date || getTodayISO();

  const handleRemarkChange = (row, rowIndex, value) => {
    setRemarkInputs((current) => ({
      ...current,
      [getRowKey(row, rowIndex)]: value,
    }));
  };

  const handleSubmitRemark = async (row, rowIndex) => {
    const rowKey = getRowKey(row, rowIndex);
    const reasonId = selectedReasons[rowKey];
    const remarks = remarkInputs[rowKey]?.trim();
    const deploymentDate = getDeploymentDate(row);

    if (!row.vehicleId || !reasonId || !remarks || !deploymentDate) return;

    try {
      setSubmittingRows((current) => ({ ...current, [rowKey]: true }));
      await saveVehicleNotDeployedRemark({
        vehicleId: row.vehicleId,
        deploymentDate,
        reasonId: Number(reasonId),
        remarks,
      });
      // Immediately mark row as saved so dropdown/input/button are replaced with text
      setSavedRemarks((current) => [
        ...current.filter((remark) => String(remark.vehicleId) !== String(row.vehicleId)),
        { vehicleId: row.vehicleId, deploymentDate, reasonId: Number(reasonId), remarks },
      ]);
      // Re-fetch from server to ensure state is in sync
      await fetchSavedRemarks(deploymentDate);
    } catch (error) {
      console.error("Error saving vehicle not deployed remark:", error);
    } finally {
      setSubmittingRows((current) => ({ ...current, [rowKey]: false }));
    }
  };
  const canWriteData = JSON.parse(localStorage.getItem("rolePermissions") || "[]");
  const canwrite = canWriteData.find((mapping) => mapping.permissionId === 31);
  console.log("not-reported-ward-zone", canwrite)

  const vehicleReportColumns = [
    {
      name: "S.No",
      selector: (row) => row["slno"],
      sortable: true,
      format: (row, rowIndex) => rowIndex + 1,
      width: '70px'
    },
    {
      name: "Corporation",
      selector: (row) => row["corporationName"],
      cell: (row) => <span>{row["corporationName"] || "N/A"}</span>,
      sortable: true,
      width: '130px'
    },
    {
      name: "Zone",
      selector: (row) => row["zoneName"],
      cell: (row) => <span>{row["zoneName"] || "N/A"}</span>,
      sortable: true,
      width: '120px'

    },
    {
      name: "Circle",
      selector: (row) => row["circleName"],
      cell: (row) => <span>{row["circleName"] || "N/A"}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: "Ward",
      selector: (row) => row["wardName"],
      cell: (row) => <span> {row["wardName"] || "N/A"}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: <>Vehicle Type</>,
      selector: (row) => row["vehicleTypeName"],
      cell: (row) => <span>{row["vehicleTypeName"] || "N/A"}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: <>Vehicle Owner</>,
      selector: (row) => row["ownerTypeName"],
      cell: (row) => <span>{row["ownerTypeName"]}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: <>Vehicle Number</>,
      selector: (row) => row["vehicleNumber"],
      cell: (row) => <span>{row["vehicleNumber"] || "N/A"}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: <>Driver Name</>,
      selector: (row) => row["driverName"],
      cell: (row) => <span>{row["driverName"] || "N/A"}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: <>Driver Number</>,
      selector: (row) => row["driverNumber"],
      cell: (row) => <span>{row["driverNumber"] || "N/A"}</span>,
      sortable: true,
      width: '120px'
    },
    {
      name: "SFA Name",
      selector: (row) => row["primaryDeploymentInchargeName"],
      cell: (row) => (
        <span>{row["primaryDeploymentInchargeName"] || "N/A"}</span>
      ),
      sortable: true,
      width: '120px'
    },
    {
      name: <>SFA Number</>,
      selector: (row) => row["primaryDeploymentInchargeNumber"],
      cell: (row) => (
        <span>{row["primaryDeploymentInchargeNumber"] || "N/A"}</span>
      ),
      sortable: true,
      //  width: '120px'
    },
    {
      name: <>Reason</>,
      selector: (row) => selectedReasons[getRowKey(row)],
      cell: (row, rowIndex) => {
        const rowKey = getRowKey(row, rowIndex);
        const savedRemark = getSavedRemark(row);
        const selectedReason = selectedReasons[rowKey] ?? getSavedReasonId(savedRemark) ?? "";

        if (savedRemark) {
          return <span>{getReasonLabelById(selectedReason)}</span>;
        }

        return (
          canwrite?.canWrite && <select
            aria-label={`Select reason for ${row.vehicleNumber || "vehicle"}`}
            className="form-select form-select-sm"
            value={selectedReason}
            onChange={(event) => handleReasonChange(row, rowIndex, event.target.value)}
          >
            <option value="">Select reason</option>
            {notDeployedReasons.map((reason, index) => {
              const value = getReasonValue(reason) ?? index;
              return (
                <option key={value} value={value}>
                  {getReasonLabel(reason) || "Unnamed reason"}
                </option>
              );
            })}
          </select>
        );
      },
      sortable: false,
      width: '200px'
    },

    {
      name: <>Remark's</>,
      selector: (row) => getSavedRemarkText(getSavedRemark(row)),
      cell: (row, rowIndex) => {
        const savedRemark = getSavedRemark(row);
        return savedRemark ? (
          <span>{getSavedRemarkText(savedRemark)}</span>
        ) : (
          canwrite?.canWrite && <input
            type="text"
            className="form-control form-control-sm"
            placeholder="Enter remark"
            value={remarkInputs[getRowKey(row, rowIndex)] || ""}
            onChange={(event) => handleRemarkChange(row, rowIndex, event.target.value)}
            disabled={!selectedReasons[getRowKey(row, rowIndex)]}
          />
        );
      },
      sortable: false,
      width: '240px'
    },

    {
      id: "action",
      name: <>Action</>,
      cell: (row, rowIndex) => {
        const rowKey = getRowKey(row, rowIndex);
        const isSaved = Boolean(getSavedRemark(row));
        const isSubmitting = Boolean(submittingRows[rowKey]);
        const canSubmit = Boolean(
          row.vehicleId &&
          getDeploymentDate(row) &&
          selectedReasons[rowKey] &&
          remarkInputs[rowKey]?.trim()
        );

        if (isSaved) return null;

        return (
          canwrite?.canWrite && (
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => handleSubmitRemark(row, rowIndex)}
              disabled={isSubmitting || !canSubmit}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          )
        );
      },
      sortable: false,
      width: '130px'
    },

    // {
    //   name: "Vehicle Image",

    //   cell: (row) => {
    //     if (row["vehicleImageUrl"]) {
    //       return (
    //         <img
    //           src={row["vehicleImageUrl"]}
    //           alt="Vehicle"
    //           style={{ maxWidth: "100px", maxHeight: "100px" }}
    //         />
    //       );
    //     } else {
    //       return <span>No image</span>;
    //     }
    //   },
    //   sortable: true,
    // },
  ];

  const filteredColumns = canwrite?.canWrite
    ? vehicleReportColumns
    : vehicleReportColumns.filter(col => col.id !== "action");


  useEffect(() => {
    const fetchZoneName = async () => {
      try {
        const zoneData = await GetZone();
        const zoneIdFromLocalStorage = localStorage.getItem("zoneId");
        const zoneNamesDictionary = {};

        // Populate the zoneNamesDictionary with zoneId as keys and zoneName as values
        zoneData.forEach((zone) => {
          zoneNamesDictionary[zone.zoneId] = zone.zoneName;
        });

        // Find the zone name corresponding to the zoneId from localStorage
        const zoneName = zoneNamesDictionary[zoneIdFromLocalStorage];

        // Use zoneName as needed
        setZoneName(zoneName);
      } catch (error) {
        console.error("Error fetching zone name:", error);
      }
    };

    fetchZoneName();
  }, []);

  useEffect(() => {
    fetchData(); // Fetch data when component mounts with default selected dates
  }, []);

  useEffect(() => {
    const fetchNotDeployedReasons = async () => {
      try {
        const response = await getVehicleNotDeployedReasons();
        setNotDeployedReasons(Array.isArray(response) ? response : response?.data || []);
      } catch (error) {
        console.error("Error fetching vehicle not deployed reasons:", error);
      }
    };

    fetchNotDeployedReasons();
  }, []);

  const fetchSavedRemarks = useCallback(async (dateOverride) => {
    const selectedDate = dateOverride !== undefined ? dateOverride : (zoneWiseFilters.date || getTodayISO());
    if (!selectedDate) return;
    try {
      const response = await getVehicleNotDeployedRemarks(selectedDate);
      setSavedRemarks(Array.isArray(response) ? response : response?.data || []);
    } catch (error) {
      console.error("Error fetching vehicle not deployed remarks:", error);
    }
  }, [zoneWiseFilters.date]);

  // Fetch saved remarks on mount (handles navigate-back scenario)
  useEffect(() => {
    fetchSavedRemarks();
  }, []);

  // Re-fetch when the selected date changes
  useEffect(() => {
    setSavedRemarks([]);
    setSelectedReasons({});
    setRemarkInputs({});
    fetchSavedRemarks();
  }, [zoneWiseFilters.date]);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      const response = allZones
        ? await innerTotalgetNotReportedAtWard1({ Date: reportDate, VehicleTypeId: VehicleTypeId || "", corporationId, CollectionTypeId, ownerTypeId, vehicleId, transferStationId, vehicleNumber })
        : await innergetNotReportedAtWard({ ZoneId, Date: reportDate, VehicleTypeId: VehicleTypeId || "", corporationId, CollectionTypeId, ownerTypeId, vehicleId, transferStationId, vehicleNumber });
      setZonesData(response);
      setsatNotReportedWard(response);
      // Handle the response data as needed
    } catch (error) {
      console.error("Error fetching Vehicle wise report:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadAsExcel = async () => {
    // Create a new workbook and add a worksheet
    const currentDate = new Date();
    const formattedDates = `${currentDate.getDate()}-${currentDate.getMonth() + 1
      }-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const cumulativeHeadingReport = `SATs Zone Wise Not Reported at Ward Report on ${zoneWiseFilters.date ? formattedDate(zoneWiseFilters.date) : getCurrentISTDate()} (at ${getCurrentDateTime1()})`;

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Zones");

    // Define styles
    const boldFont = { bold: true };

    // Add row for download date and time
    const downloadDateTime = `Reported on: ${formattedDates} ${formattedTime}`;
    const dateTimeRow = worksheet.addRow(["", "", downloadDateTime, "", ""]);
    worksheet.mergeCells(1, 3, 1, 5);
    dateTimeRow.getCell(3).font = boldFont; // Set style for the cell
    dateTimeRow.getCell(3).alignment = { horizontal: "center" }; // Center align the cell content
    dateTimeRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 5) {
        // Apply styles to download date and time cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add row for cumulative heading report
    const cumulativeHeadingRow = worksheet.addRow(["", "", cumulativeHeadingReport, "", ""]);
    worksheet.mergeCells(2, 3, 2, 6);
    cumulativeHeadingRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      if (colNumber >= 3 && colNumber <= 7) {
        // Apply styles to cumulative heading report cells
        cell.font = boldFont;
        cell.alignment = { horizontal: "center" };
      }
    });

    // Add empty row for spacing
    worksheet.addRow([""]);

    // Add table header row with bold font
    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "Corporation",
      "Zone",
      "Circle",
      "Ward",
      "Vehicle Type",
      "Vehicle Owner",
      "Vehicle Number",
      "Driver Name",
      "Driver Number",
      "SFA Name",
      "SFA Number",
      "Reason",
      "Remarks"

    ]);

    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = boldFont;
      cell.alignment = { horizontal: "left" }; // Left align the cell content
      if (colNumber >= 1 && colNumber <= 14) {
        // Apply background color only to specific cells
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "F6B1B1" } // Red background color
        };
      }
    });

    // Add data rows
    const rowsToExport = Array.isArray(satNotReportedWard) ? satNotReportedWard : [];
    rowsToExport.forEach((item, index) => {
      const savedRemark = getSavedRemark(item);
      const reasonLabel = savedRemark ? getReasonLabelById(getSavedReasonId(savedRemark)) : "";
      const remarkText = savedRemark ? getSavedRemarkText(savedRemark) : "";
      worksheet.addRow([
        index + 1,
        item.corporationName ?? "N/A",
        item.zoneName ?? "N/A",
        item.circleName ?? "N/A",
        item.wardName ?? "N/A",
        item.vehicleTypeName ?? "N/A",
        item.ownerTypeName ?? "N/A",
        item.vehicleNumber ?? "N/A",
        item.driverName ?? "N/A",
        item.driverNumber ?? "N/A",
        item.primaryDeploymentInchargeName ?? "N/A",
        item.primaryDeploymentInchargeNumber ?? "N/A",
        reasonLabel || "N/A",
        remarkText || "N/A"
      ]).eachCell({ includeEmpty: true }, (cell, colNumber) => {
        if (colNumber >= 1 && colNumber <= 14) {
          // Align the columns from 1 to 4 to the left
          cell.alignment = { horizontal: "left" };
        } else {
          // Align the rest of the columns to the center
          cell.alignment = { horizontal: "center" };
        }
      });
    });

    // Set column widths dynamically based on content
    worksheet.columns = [
      { width: 5 },   // S.No
      { width: 20 },  // Corporation
      { width: 20 },  // Zone
      { width: 20 },  // Circle
      { width: 23 },  // Ward
      { width: 23 },  // Vehicle Type
      { width: 20 },  // Vehicle Owner
      { width: 20 },  // Vehicle Number
      { width: 20 },  // Driver Name
      { width: 20 },  // Driver Number
      { width: 25 },  // SFA Name
      { width: 26 },  // SFA Number
      { width: 25 },  // Reason
      { width: 35 },  // Remarks
    ];

    // Save the workbook to a file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, "ZoneWiseNotReportedatWardReport.xlsx");
  };

  const handleExcelDownload = () => {
    downloadAsExcel().catch((error) => {
      console.error("Error downloading not reported at ward Excel report:", error);
      toast.error("Unable to download the Excel report. Please try again.");
    });
  };



  // Filterss
  const filterFields = { searchCircle: "", searchWard: "", searchVehicleNumber: "", searchPrimaryDeploymentInchargeName: "" };

  const searchReportedAtVehicleHandler = (values) => {
    const termCircle = values.searchCircle ? values.searchCircle.toLowerCase() : "";
    const termWard = values.searchWard ? values.searchWard.toLowerCase() : "";
    const termVehicleNumber = values.searchVehicleNumber ? values.searchVehicleNumber.toLowerCase() : "";
    const termSFAIncharge = values.searchSFAIncharge ? values.searchSFAIncharge.toLowerCase() : "";

    const filteredData = (Array.isArray(satNotReportedWard) ? satNotReportedWard : []).filter(item => {
      const circleName = item?.circleName ? item.circleName.toLowerCase() : "";
      const vehicle = item?.wardName ? item.wardName.toLowerCase() : "";
      const vehicleNumber = item?.vehicleNumber ? item.vehicleNumber.toLowerCase() : "";
      const SFAIncharge = item?.primaryDeploymentInchargeName ? item.primaryDeploymentInchargeName.toLowerCase() : "";
      const SFAInchargeNumber = item?.primaryDeploymentInchargeNumber ? item.primaryDeploymentInchargeNumber.toString() : "";
      const matchesCircle = !termCircle || circleName.includes(termCircle);
      const matchesWard = !termWard || vehicle.includes(termWard);
      const matchesVehicleNumber = !termVehicleNumber || vehicleNumber.includes(termVehicleNumber);
      const matchesSFAName = !termSFAIncharge || SFAIncharge.includes(termSFAIncharge);

      const isNumber = /^[0-9]+$/.test(termSFAIncharge);
      const matchesSFA = !termSFAIncharge ||
        SFAIncharge.includes(termSFAIncharge) ||
        (isNumber && SFAInchargeNumber.includes(termSFAIncharge));

      return matchesCircle && matchesWard && matchesVehicleNumber && matchesSFA;
    });

    setsatNotReportedWard(filteredData);
  };

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="content">
          <div className="page-content">
            <div className="page-header">
              {/* <div class="row" style={{ textAlign: "justify" }}>
            </div> */}

              <div className="card">
                <div className="card-body">
                  <div className="row align-items-end mt-3">
                    <div className="col-md-9">
                      <div className="row">


                        <Formik initialValues={filterFields}>
                          {({ handleChange, values }) => (
                            <Form >
                              <div className="row">
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <Field
                                      name="searchCircle"
                                      placeholder="Search Circle"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        searchReportedAtVehicleHandler({ ...values, searchCircle: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <Field
                                      name="searchWard"
                                      placeholder="Search Ward"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        searchReportedAtVehicleHandler({ ...values, searchWard: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <Field
                                      name="searchVehicleNumber"
                                      placeholder="Search Vehicle Number"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        searchReportedAtVehicleHandler({ ...values, searchVehicleNumber: e.target.value });
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3">
                                  <div className="form-group">
                                    <Field
                                      name="searchSFAIncharge"
                                      placeholder="Search SFA Incharge Name or Number"
                                      type="text"
                                      className="form-control bg-white"
                                      onInput={(e) => {
                                        handleChange(e);
                                        const searchValue = e.target.value.trim();

                                        // Check if input is a number or name
                                        const isNumber = /^[0-9]+$/.test(searchValue);

                                        // Send appropriate search query
                                        searchReportedAtVehicleHandler({
                                          ...values,
                                          searchSFAIncharge: searchValue, // Keep the same key for both name & number
                                          searchBy: isNumber ? "number" : "name" // Add a key to indicate search type
                                        });
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </Form>
                          )}
                        </Formik>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="d-flex justify-content-end mt-3 mb-3">
                        <button className="btn btn-secondary  me-2" style={{}}
                          onClick={() => navigate(-1, { state: data })}
                        >
                          Back
                        </button>
                        <button className="btn btn-excel"
                          onClick={handleExcelDownload}
                        >
                          <i class="fa-solid fa-file-excel me-1 icon-container"></i> Excel
                        </button>

                      </div>
                    </div>




                  </div>
                  <div className="top-header">

                    <span>
                      {" "}
                      SATs Zone Wise Not Reported At Ward Report on {zoneWiseFilters.date ? formattedDate(zoneWiseFilters.date) : getCurrentISTDate()} (at {getCurrentDateTime1()})
                    </span>
                  </div>

                 { isLoading?<TableSkeleton/>: <CustomDataTable
                    showTotal={false}
                    //data={zonesData}
                    data={satNotReportedWard}
                    //  data={modifiedData}
                    columns={filteredColumns}
                  // headers={headers}
                  // link={true}
                  // search={true}
                  // fromDate={fromDate}
                  // toDate={toDate}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
    </>
  );
};

export default NotReportedAtWard;
